import store from "..";
import { selectedDate } from "../actionTypes"

export const selectedDay = (data) => {
    return {
        type: selectedDate.LOAD_SELECTED_DATE,
        payload: data
    }
}

export const selectedEndDay = (data) => {
    return {
        type: selectedDate.LOAD_SELECTED_END_DATE,
        payload: data
    }
}